import { 
  APP_LOAD,
  REDIRECT,
  REDIRECT_TO,
  
  LOGIN,
  LOGOUT,
  REGISTRATION,
  
  LOAD_PROFILE,
  RELOAD_PROFILE,
  UPDATE_PROFILE,
  
  LOAD_PROJECT,
  FETCH_PROJECTS,
  CREATE_PROJECT,
  UPDATE_PROJECT,
  DESTROY_PROJECT,
  
  UPDATE_SUBSCRIPTION,
  UPDATE_PAYMENT_METHOD,
  REDEEM_COUPON,
  
  CREATE_MEMBER,
  DESTROY_MEMBER,
  
  CREATE_DOMAIN,
  UPDATE_DOMAIN,
  DESTROY_DOMAIN,
  
  FETCH_PIXEL_SETS,
  CREATE_PIXEL_SET,
  UPDATE_PIXEL_SET,
  DESTROY_PIXEL_SET,
  
  FETCH_LINKS,
  FETCH_LINK,
  CREATE_LINK,
  UPDATE_LINK,
  DESTROY_LINK,
  
  FETCH_TAGS,
  FETCH_NOTIFICATIONS,
  DESTROY_NOTIFICATION_MESSAGE
  // REMOVE_LINK_PIXEL_SET
} from './actionTypes';

// import { apiAction } from '../utils/api';
import * as Api from '../api';

//
// export const helloWorld = (params) => {
//   return apiAction.get(HELLO_WORLD, '/', params)
// }


export const ProjectCableDispatch = (data) => ({...data})
export const AdminCableDispatch = (data) => ({...data})



// Profile
export const loadProfile = () => ({
  type: LOAD_PROFILE,
  payload: Api.currentUser()
})

export const reloadProfile = () => ({
  type: RELOAD_PROFILE,
  payload: Api.currentUser()
});

export const updateProfile = (payload) => ({
  type: UPDATE_PROFILE,
  payload: Api.currentUser()
})

export const updateProfileSuccess = (payload) => ({
  type: UPDATE_PROFILE.SUCCESS,
  payload: payload
})


// Project
export const loadProject = (id = null, successPayload = {}) => ({
  type: LOAD_PROJECT,
  payload: Api.currentProject(id).then((res) => ({...res, ...successPayload}))
})
export const loadProjectSuccess = (project) => ({
  type: LOAD_PROJECT.SUCCESS,
  payload: project
})
export const listProjects = (params) => ({
  type: FETCH_PROJECTS,
  payload: Api.Project.list(params)
})
export const addProjectSuccess = (project) => ({
  type: CREATE_PROJECT.SUCCESS,
  payload: project
})
export const updateProjectSuccess = (project) => ({
  type: UPDATE_PROJECT.SUCCESS,
  payload: project
})
export const deleteProject = (project) => ({
  type: DESTROY_PROJECT,
  payload: Api.Project.destroy({id:project.id})
})
export const deleteProjectSuccess = (project) => ({
  type: DESTROY_PROJECT.SUCCESS,
  payload: project
})


export const loadApp = (user = null, projectId = null) => ({
  type: APP_LOAD,
  payload: Api.hasToken() ? Promise.all([user || Api.currentUser(), Api.currentProject(projectId)]) : Promise.reject({statusCode: 401})
})

export const onRedirect = () => ({
  type: REDIRECT
});
export const redirectTo = (path) => ({
  type: REDIRECT_TO,
  payload: path
});


// Session
// export const loginSubmit = (email, password) => {
//   return apiAction.post(LOGIN, '/users/sign_in', {user:{ email, password }})
// }
export const loginSuccess = (payload) => {
  return {
    type: LOGIN.SUCCESS,
    payload
  }
}
export const loginUnload = () => ({
  type: LOGIN.UNLOAD
});

export const logout = () => {
  return {
    type: LOGOUT,
    payload: Api.logout()
  }
};


// Registration
export const registrationSuccess = (payload) => {
  if (window.fbq){
    window.fbq('track', 'CompleteRegistration');
  }
  if (window.yaCounter49184755 && window.yaCounter49184755.reachGoal){
    window.yaCounter49184755.reachGoal('account_created')
  }
  if (window.gtag){
    window.gtag('config', 'ga_id', {'page_path': '/signup/success'});
  }
  if (window.qp){
    window.qp('track', 'CompleteRegistration');
  }
  
  return {
    type: REGISTRATION.SUCCESS,
    payload
  }
}

export const registrationUnload = () => ({
  type: REGISTRATION.UNLOAD
});



// Money
export const updateSubscription = (params) => ({
  type: UPDATE_SUBSCRIPTION,
  payload: Api.Account.updateSubscription(params)
});
export const updateSubscriptionSuccess = (data) => ({
  type: UPDATE_SUBSCRIPTION.SUCCESS,
  payload: data
});
export const updatePaymentMethod = (params) => ({
  type: UPDATE_PAYMENT_METHOD,
  payload: Api.PaymentMethod.update(params)
});

// Coupon
export const redeemCouponSuccess = (data) => ({
  type: REDEEM_COUPON.SUCCESS,
  payload: data
});



// Notifications
export const loadNotifications = () => {
  return {
    type: FETCH_NOTIFICATIONS,
    payload: Api.Notifications.list()
  }
}

export const deleteNotificationMessage = (idx) => {
  return {
    type: DESTROY_NOTIFICATION_MESSAGE.SUCCESS,
    payload: {idx}
  }
}

// Members
export const addMemberSuccess = (member) => ({
  type: CREATE_MEMBER.SUCCESS,
  payload: member
})
export const deleteMemberSuccess = (member) => ({
  type: DESTROY_MEMBER.SUCCESS,
  payload: member
})

// Domains
export const addDomainSuccess = (domain) => ({
  type: CREATE_DOMAIN.SUCCESS,
  payload: domain
})
export const deleteDomainSuccess = (domain) => ({
  type: DESTROY_DOMAIN.SUCCESS,
  payload: domain
})
export const updateDomainSuccess = (domain) => ({
  type: UPDATE_DOMAIN.SUCCESS,
  payload: domain
});


// Pixel Sets
export const listPixelSets = (params) => ({
  type: FETCH_PIXEL_SETS,
  payload: Api.PixelSet.list(params)
})
export const addPixelSetSuccess = (pixel) => ({
  type: CREATE_PIXEL_SET.SUCCESS,
  payload: pixel
})
export const updatePixelSetSuccess = (pixel) => ({
  type: UPDATE_PIXEL_SET.SUCCESS,
  payload: pixel
})
export const deletePixelSet = (pixel) => ({
  type: DESTROY_PIXEL_SET,
  payload: Api.PixelSet.destroy({id:pixel.id})
})
export const deletePixelSetSuccess = (pixel) => ({
  type: DESTROY_PIXEL_SET.SUCCESS,
  payload: pixel
})


// Links
export const listLinks = (params) => ({
  type: FETCH_LINKS,
  payload: Api.Link.list(params)
})
export const fetchLink = (id) => ({
  type: FETCH_LINK,
  payload: Api.Link.get({id}),
  data: {id}
})
export const addLinkSuccess = (link) => ({
  type: CREATE_LINK.SUCCESS,
  payload: link
})

export const updateLink = (link) => ({
  type: UPDATE_LINK,
  payload: Api.Link.update(link)
})
export const updateLinkSuccess = (link) => ({
  type: UPDATE_LINK.SUCCESS,
  payload: link
})

export const deleteLink = (link) => ({
  type: DESTROY_LINK,
  payload: Api.Link.destroy({id:link.id})
})

export const deleteLinkSuccess = (link) => ({
  type: DESTROY_LINK.SUCCESS,
  payload: link
})

export const removeLinkPixelSet = (linkId, pixelSetIds) => ({
  type: DESTROY_LINK.SUCCESS,
  payload: Api.Link.update({id: linkId, pixel_set_ids: pixelSetIds})
})



// Tags
export const listTags = () => ({
  type: FETCH_TAGS,
  payload: Api.tags()
});









// WEBPACK FOOTER //
// ./src/actions/index.js